/* eslint-disable react/no-array-index-key */
/* eslint-disable no-nested-ternary */
import React from 'react'
import { shape, arrayOf, string } from 'prop-types'
import { getCurrentViewPort } from 'services/utility'
import AsdaCustomLink from 'components/asda-custom-link'
import SubMenuHamBurger from 'components/secondary-nav/SubMenuHamBurger'

const GuidedNav = ({
  moduleData: {
    Menu: sectionMain,
  },
  ui,
  name,
  type,
  moduleId,
}) => {
  const viewPort = getCurrentViewPort()
  let isExtendedMenu = true
  if (viewPort === 'small' || viewPort === 'medium' || viewPort === 'large') {
    isExtendedMenu = false
  }
  const isSubNavPresent = sectionMain.some(menu => menu.SubNav)
  return (
    <React.Fragment>
      <ul
        data-module={name}
        data-module-name={name}
        data-module-id={moduleId}
        data-module-type={type}
      >
        {sectionMain.map(({
        MainMenu: {
          link: {
            clickThrough: {
              value,
            },
            title,
          },
          IsSubNav: isSubNav,
        },
        SubNav,
    }, index) => {
        const linkObj = { path: value }
        return isSubNav === 'true' ? (isExtendedMenu ? <SubMenuHamBurger
          link={linkObj}
          linkName={title}
          ui={ui}
          key={`SubMenuHamBurger-${index}`}
        /> : (SubNav ? SubNav.map(({
        link: {
            clickThrough: {
              value,
            },
            title,
        },
        }, index) => {
          const linkObj = { path: value }
        return <AsdaCustomLink link={linkObj} linkName={title} key={`AsdaCustomLink-${index}`} />
        }) : null))
        : <AsdaCustomLink
            link={linkObj}
            linkName={title}
            key={`AsdaCustomLink-${index}`}
        />
        })}

      </ul>
      {isExtendedMenu && isSubNavPresent ?
        <ul className={ui.subMenuOpen ? 'submenu-nav open' : 'submenu-nav'} >
          {sectionMain.map(({
            SubNav,
            MainMenu: {
              IsSubNav: isSubNav,
            },
        }) => ((SubNav && isSubNav === 'true') ? (SubNav.map(({
        link: {
            clickThrough: {
              value,
            },
            title,
        },
        }, index) => {
          const linkObj = { path: value }
        return <AsdaCustomLink link={linkObj} linkName={title} key={`AsdaCustomLink-${index}`} />
        })) : null))}
        </ul>
      : null}
    </React.Fragment>
  )
}

GuidedNav.propTypes = {
  moduleData: shape({
    Menu: arrayOf(shape({})).isRequired,
  }).isRequired,
  ui: shape({}).isRequired,
  name: string,
  moduleId: string,
  type: string,
}

GuidedNav.defaultProps = {
  name: null,
  moduleId: null,
  type: null,
}

export default GuidedNav



// WEBPACK FOOTER //
// ./components/cms/components/guided-nav.js